module.exports = __webpack_public_path__ + "img/intro_mock.21a75e55.png";